module.exports = __webpack_public_path__ + "static/media/ca-cover.7da01edd.webp";